import { render } from "./Principal-remedialRequest.vue?vue&type=template&id=76c769bb"
import script from "./Principal-remedialRequest.vue?vue&type=script&lang=js"
export * from "./Principal-remedialRequest.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__